<template>
	<v-menu
		v-model="dateMenu"
		:close-on-content-click="false"
		:offset="40"
		lazy
		transition="scale-transition"
		full-width
		max-width="290px"
		min-width="290px"
	>
		<template #activator="{ props }">
			<v-combobox
				prepend-icon="$calendarEvent"
				readonly
				:model-value="dates"
				v-bind="props"
			>
				<template #selection>
					<v-chip
						v-for="(item , index) in dates"
						:key="index"
						class="ma-1"
					>
						{{ item }}
					</v-chip>
				</template>
				<template
					v-for="(_, slot) of $slots"
					#[slot]="scope"
				>
					<slot
						:name="slot"
						v-bind="scope"
					/>
				</template>
			</v-combobox>
		</template>
		<v-date-picker
			v-model="dates"
			color="primary"
			no-title
			multiple
		/>
	</v-menu>
</template>

<script>
export default {
	name: 'MultiDatePicker',

	props: {
		currentLanguage: {
			type: String,
			required: false,
			default: 'en',
		},
		value: {
			type: Array,
			required: false,
			default: null
		}
	},

	emits: ['input',],

	data () {
		return {
			dateMenu: false,
			dates: null,
		};
	},

	watch: {
		dates () {
			this.$emit('input', this.dates);
		}
	},

	mounted () {
		this.dates = this.value;
	}
};
</script>
